import gql from 'graphql-tag';

export const gqlGetQuery = gql`
  query getMailsrepo($limit: Int, $offset: Int, $order: String, $where: String) {
    getMailsrepo(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        originatedFrom
        from
        to
        cc
        subject
        text
        html
        composedDate
        sendDate
        failedDate
        failedReason
        failedDetails
        isDeleted
      }
      recordCount
    }
  }
`;

export const gqlClearUnsendMailsMutation = gql`
  mutation clearUnsendMails {
    clearUnsendMails
  }
`;
